<template>
  <div class="digitize_banner">
    <div>
      <img src="../assets/case.jpg" />
      <div class="wenan">
        <div class="wen_title">数字化服务</div>
        <div class="wen_content">
          以满足客户流程数字化管控+智慧物联场景建设需求为核心 <br />
          帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化
        </div>
      </div>
    </div>
  </div>
  <div class="contaier digitize">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>数字化</span>
            <span class="red">服务</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">DIGITIZE</div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          border-radius: 1.04vw;
          border: 0.2px solid #efefef;
          padding: 10px;
          padding-right: 30px;
          padding-left: 20px;
          margin-bottom: 30px;
        "
      >
        <div class="fw_wen">
          <p>
            2025年漳州市为做好中小企业数字化转型试点城市建设工作，漳州工信局展开“第一批中小企业数字化转型城市试点数字化服务商”的征集工作。经过有关部门综合审核，福建科控自动化科技有限公司成为漳州市中小企业数字化转型城市试点第一批数字化服务商。
          </p>
          <p>
            福建科控自化科技有限公司以满足客户流程数字化管控+智慧物联场景建设需求为核心，帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化。
          </p>
        </div>
        <img src="../assets/fws.png" style="width: 31%; margin-left: 2%" />
      </div>
      <div class="digitize_content">
        <div class="digitize_model flex">
          <div v-if="this.clickDig == 1" class="dig_item">
            <div class="digitize_item_d">企业数字化服务</div>
          </div>
          <div v-else class="dig_item" @click="change(1)">
            <div class="digitize_item">企业数字化服务</div>
          </div>
          <div v-if="this.clickDig == 2" class="dig_item">
            <div class="digitize_item_d">数字化项目申报</div>
          </div>
          <div v-else class="dig_item" @click="change(2)">
            <div class="digitize_item">数字化项目申报</div>
          </div>
        </div>
        <div v-if="this.clickDig == 1" class="digitize_service">
          <div class="digi_title">数字化经营应用场景服务</div>
          <div class="digi_title_detail">
            为企业做好数字化服务，帮助企业更好的管理从供应链、生产到销售过程中的采购管理、仓储管理、工艺设计、计划排程、生产管控、质量管理、设备管理、营销管理、财务管理、决策支持等经营应用场景，<br />进而实现企业经营管理中的数据实时性、过程可视性与协作高效性，提高企业经营效率、应变能力、决策能力，为企业降低成本与风险、构建企业核心竞争力。
          </div>
          <div
            style="
              text-align: center;
              padding-bottom: 10px;
              animation: flyBottomIn 0.5s ease-out forwards;
            "
          >
            <img src="../assets/szhfa.png" />
          </div>
          <div class="flex" style="margin: 10px; height: 100px">
            <div class="title_img">
              <img v-if="this.model == 'jhpc'" src="../assets/jhpc.png" class="tit_img" />
              <img
                v-else
                src="../assets/jhpc.png"
                @click="replace('jhpc')"
                class="t_img"
              />
              <div class="t_img_wen">计划排程</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'scgl'" src="../assets/scgl.png" class="tit_img" />
              <img
                v-else
                src="../assets/scgl.png"
                @click="replace('scgl')"
                class="t_img"
              />
              <div class="t_img_wen">生产管控</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'zlgl'" src="../assets/zlgl.png" class="tit_img" />
              <img
                v-else
                src="../assets/zlgl.png"
                @click="replace('zlgl')"
                class="t_img"
              />
              <div class="t_img_wen">质量管理</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'sbgl'" src="../assets/sbgl.png" class="tit_img" />
              <img
                v-else
                src="../assets/sbgl.png"
                @click="replace('sbgl')"
                class="t_img"
              />
              <div class="t_img_wen">设备管理</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'yxgl'" src="../assets/yxgl.png" class="tit_img" />
              <img
                v-else
                src="../assets/yxgl.png"
                @click="replace('yxgl')"
                class="t_img"
              />
              <div class="t_img_wen">营销管理</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'cggl'" src="../assets/cggl.png" class="tit_img" />
              <img
                v-else
                src="../assets/cggl.png"
                @click="replace('cggl')"
                class="t_img"
              />
              <div class="t_img_wen">采购管理</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'ccgl'" src="../assets/ccgl.png" class="tit_img" />
              <img
                v-else
                src="../assets/ccgl.png"
                @click="replace('ccgl')"
                class="t_img"
              />
              <div class="t_img_wen">仓储管理</div>
            </div>
            <div class="title_img">
              <img v-if="this.model == 'jczc'" src="../assets/jczc.png" class="tit_img" />
              <img
                v-else
                src="../assets/jczc.png"
                @click="replace('jczc')"
                class="t_img"
              />
              <div class="t_img_wen">决策支持</div>
            </div>
          </div>
          <div
            v-if="this.isModelDetail"
            :key="this.modelDetailKey"
            style="margin-top: 30px; margin-bottom: 50px"
          >
            <div class="digi_detail_tit">
              {{ this.modelDetail.titel }}
            </div>
            <div v-for="(item, index) in this.modelDetail.data" :key="item.id">
              <div class="digi_detail_left" v-if="index % 2 == 0">
                <div class="digi_detail_wen">
                  <div class="jiachu" style="font-size: 20px">{{ item.titel }}</div>
                  <div><span class="jiachu">功能：</span>{{ item.function }}</div>
                  <div class="jiachu">信息内容：</div>
                  <div
                    v-for="str in item.content"
                    :key="str"
                    style="padding-left: 20px; height: 30px; line-height: 30px"
                  >
                    {{ str }}
                  </div>
                  <div><span class="jiachu">目标：</span>{{ item.target }}</div>
                  <div v-if="this.model == 'ccgl' && item.process">
                    <span class="jiachu">流程：</span>
                    {{ item.process }}
                  </div>
                  <div style="margin: 10px">
                    <el-button
                      type="primary"
                      plain
                      style="height: 42px; width: 140px"
                      @click="openUs(item.titel)"
                      >了解更多 →</el-button
                    >
                  </div>
                </div>
                <div class="digi_detail_img">
                  <img v-if="item.img" :src="item.img" />
                  <img v-else src="../assets/jhpc.png" />
                </div>
              </div>
              <div v-else class="digi_detail_right" style="background: #f6fbff">
                <div class="digi_detail_img" style="width: 60%">
                  <img v-if="item.img" :src="item.img" />
                  <img v-else src="../assets/jhpc.png" />
                </div>
                <div>
                  <div class="jiachu" style="font-size: 20px">{{ item.titel }}</div>
                  <div><span class="jiachu">功能：</span>{{ item.function }}</div>
                  <div class="jiachu">信息内容：</div>
                  <div
                    v-for="str in item.content"
                    :key="str"
                    style="height: 30px; line-height: 30px; padding-left: 20px"
                  >
                    {{ str }}
                  </div>
                  <div><span class="jiachu">目标：</span>{{ item.target }}</div>
                  <div v-if="this.model == 'ccgl' && item.process">
                    <span class="jiachu">流程：</span>
                    {{ item.process }}
                  </div>
                  <div style="margin: 10px">
                    <el-button
                      type="primary"
                      plain
                      style="height: 42px; width: 140px"
                      @click="openUs(item.titel)"
                      >了解更多 →</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog v-model="usVisible" width="50%" center>
          <div class="mes">
            <div class="us_mes_title">在线咨询</div>
            <div class="mes-from">
              <el-form :model="messageFrom" :rules="rules" ref="messageFrom">
                <el-form-item
                  label="名称："
                  prop="name"
                  label-width="120px"
                  style="height: 50px; font-size: 18px"
                >
                  <el-input
                    v-model="messageFrom.name"
                    placeholder="怎么称呼您"
                    style="height: 50px; font-size: 18px"
                  />
                </el-form-item>
                <el-form-item
                  label="联系电话："
                  prop="contact"
                  label-width="120px"
                  style="height: 50px; font-size: 18px"
                >
                  <el-input
                    v-model="messageFrom.contact"
                    placeholder="如何联系您"
                    style="height: 50px; font-size: 18px"
                  />
                </el-form-item>
                <el-form-item
                  label="邮箱："
                  prop="email"
                  label-width="120px"
                  style="height: 50px; font-size: 18px"
                >
                  <el-input
                    v-model="messageFrom.email"
                    placeholder="您的邮箱"
                    style="height: 50px; font-size: 18px"
                  />
                </el-form-item>
                <el-form-item
                  label="公司名称："
                  prop="company"
                  label-width="120px"
                  style="height: 50px; font-size: 18px"
                >
                  <el-input
                    v-model="messageFrom.company"
                    placeholder="贵公司名称"
                    style="height: 50px; font-size: 18px"
                  />
                </el-form-item>
                <el-form-item
                  label="地址："
                  prop="site"
                  label-width="120px"
                  style="height: 50px; font-size: 18px"
                >
                  <el-input
                    v-model="messageFrom.site"
                    style="height: 50px; font-size: 18px"
                  />
                </el-form-item>
                <el-form-item label="资讯内容：" prop="content" label-width="120px">
                  <el-input
                    v-model="messageFrom.content"
                    type="textarea"
                    :rows="5"
                    placeholder="您想咨询的内容"
                    style="font-size: 18px; width: 77%"
                  />
                  <img src="../assets/wx_ljd.png" style="width: 20%; margin-left: 20px" />
                </el-form-item>
              </el-form>
              <div class="mes-footer">
                <el-button
                  type="primary"
                  @click="submitMessage('messageFrom')"
                  style="height: 50px; width: 24%; font-size: 20px"
                  >提交</el-button
                >
              </div>
            </div>
          </div>
        </el-dialog>
        <div v-if="this.clickDig == 2" class="digitize_declare">
          <div class="basis">
            <div class="basis_title">一、申报企业基本信息</div>
            <div class="basis_content">
              <el-form :model="basisForm" :rules="basisRules" ref="basisForm">
                <el-form-item label="企业名称：" prop="name" label-width="300px">
                  <el-input v-model="basisForm.name" />
                </el-form-item>
                <el-form-item label="所属县（区）：" prop="site" label-width="300px">
                  <el-cascader
                    :props="this.district"
                    v-model="basisForm.site"
                    @change="handleSelectCus"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="统一社会信用代码：" prop="uscc" label-width="300px">
                  <el-input v-model="basisForm.uscc" />
                </el-form-item>
                <el-form-item label="行业代码：" prop="industry" label-width="300px">
                  <el-input
                    v-model="basisForm.industry"
                    placeholder="请按照CB/T 4754-2017（可在“服务与支持”处下载） 填写主要适用行业四位行业代码，并附行业名称。"
                  />
                </el-form-item>
                <el-form-item label="法定代表人：" prop="lr" label-width="300px">
                  <el-input v-model="basisForm.lr" />
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone" label-width="300px">
                  <el-input v-model="basisForm.phone" />
                </el-form-item>
                <el-form-item
                  label="细分行业："
                  prop="industryDetail"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="basisForm.industryDetail"
                    @change="industryDetailChange"
                  >
                    <el-checkbox label="休闲食品制造" value="休闲食品制造"></el-checkbox>
                    <el-checkbox
                      label="化工新材料及精细化工制品"
                      value="化工新材料及精细化工制品"
                    ></el-checkbox>
                    <el-checkbox
                      label="新型电子元器件"
                      value="新型电子元器件"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="注册地址：" prop="siteDetail" label-width="300px">
                  <el-input v-model="basisForm.siteDetail" />
                </el-form-item>
                <el-form-item label="企业性质：" prop="nature" label-width="300px">
                  <el-checkbox-group v-model="basisForm.nature" @change="natureChange">
                    <el-checkbox label="国有企业" value="国有企业"></el-checkbox>
                    <el-checkbox label="民营企业" value="民营企业"></el-checkbox>
                    <el-checkbox label="外资企业" value="外资企业"></el-checkbox>
                    <el-checkbox label="港澳资" value="港澳资"></el-checkbox>
                    <el-checkbox label="台资" value="台资"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="企业规模：" prop="scale" label-width="300px">
                  <el-checkbox-group v-model="basisForm.scale" @change="scaleChange">
                    <el-checkbox label="规模以上企业" value="规模以上企业"></el-checkbox>
                    <el-checkbox label="规模以下企业" value="规模以下企业"></el-checkbox>
                  </el-checkbox-group>
                  <el-button type="primary" plain style="margin-left: 30px"
                    ><a
                      href="https://baosong.miit.gov.cn/ScaleTest"
                      target="_blank"
                      style="all: unset"
                      >中小企业规模类型自测</a
                    ></el-button
                  >
                </el-form-item>
                <el-form-item
                  label="优质中小企业情况："
                  prop="situation"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="basisForm.situation"
                    @change="situationChange"
                  >
                    <el-checkbox label="无" value="无"></el-checkbox>
                    <el-checkbox
                      label="创新型中小企业"
                      value="创新型中小企业"
                    ></el-checkbox>
                    <el-checkbox
                      label="专精特新中小企业"
                      value="专精特新中小企业"
                    ></el-checkbox>
                    <el-checkbox
                      label="专精特新小巨人企业"
                      value="专精特新小巨人企业"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="2024年营业收入（万元）："
                  prop="money"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.money" />
                </el-form-item>
                <el-form-item label="2024年净利润：" prop="profit" label-width="300px">
                  <el-input v-model="basisForm.profit" />
                </el-form-item>
                <el-form-item
                  label="2024年员工数量（缴交社保人数）："
                  prop="num"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.num" />
                </el-form-item>
                <el-form-item
                  label="联系人姓名："
                  prop="contactsName"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.contactsName"></el-input>
                </el-form-item>
                <el-form-item
                  label="联系人电话："
                  prop="contactsPhone"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.contactsPhone"></el-input>
                </el-form-item>
                <el-form-item
                  label="联系人职务："
                  prop="contactsPosition"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.contactsPosition"></el-input>
                </el-form-item>
                <el-form-item
                  label="联系人邮箱："
                  prop="contactsEmail"
                  label-width="300px"
                >
                  <el-input v-model="basisForm.contactsEmail"></el-input>
                </el-form-item>
                <el-form-item
                  label="企业数字化转型预计启动时间："
                  prop="startTime"
                  label-width="300px"
                >
                  <el-date-picker
                    v-model="basisForm.startTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束时间"
                  ></el-date-picker
                ></el-form-item>
                <el-form-item label="企业基本情况：" prop="basic" label-width="300px">
                  <el-input
                    v-model="basisForm.basic"
                    type="textarea"
                    :rows="5"
                    placeholder="(主要业务简介，经营范围、主营产品、数字化转型情况，300字以内)"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="demand">
            <div class="basis_title">二、企业数字化转型需求</div>
            <div class="basis_content">
              <el-form :model="demandForm" :rules="demandRules" ref="demandForm">
                <el-form-item
                  label="现数字化水平等级："
                  prop="nowGrade"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="demandForm.nowGrade"
                    @change="nowGradeChange"
                  >
                    <el-checkbox label="无等级" value="无等级"></el-checkbox>
                    <el-checkbox label="一级" value="一级"></el-checkbox>
                    <el-checkbox label="二级" value="二级"></el-checkbox>
                    <el-checkbox label="三级" value="三级"></el-checkbox>
                    <el-checkbox label="四级" value="四级"></el-checkbox>
                  </el-checkbox-group>
                  <el-button type="primary" plain style="margin-left: 30px"
                    ><a
                      href="http://caii-sme.indusforce.com/#/Selftest"
                      target="_blank"
                      style="all: unset"
                      >数字化水平等级自测</a
                    ></el-button
                  >
                </el-form-item>
                <el-form-item
                  label="预计改造后数字化水平等级："
                  prop="futureGrade"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="demandForm.futureGrade"
                    @change="futureGradeChange"
                  >
                    <el-checkbox label="二级" value="二级"></el-checkbox>
                    <el-checkbox label="三级" value="三级"></el-checkbox>
                    <el-checkbox label="四级" value="四级"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="已部署软件：" prop="deployed" label-width="300px">
                  <el-checkbox-group
                    v-model="demandForm.deployed"
                    style="font-size: 14px; color: #606266"
                  >
                    <div>
                      研发设计类：
                      <el-checkbox label="CAD" value="CAD"></el-checkbox>
                      <el-checkbox label="CAE" value="CAE"></el-checkbox>
                      <el-checkbox label="CAPP" value="CAPP"></el-checkbox>
                      <el-checkbox label="CAM" value="CAM"></el-checkbox>
                      <el-checkbox label="数字孪生" value="数字孪生"></el-checkbox>
                      <el-checkbox
                        label="其他研发设计软件"
                        value="其他研发设计软件"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.yfsjType"
                        placeholder="请输入其他研发设计软件-具体描述"
                        v-if="this.demandForm.deployed.indexOf('其他研发设计软件') != -1"
                      ></el-input>
                    </div>
                    <div>
                      生产制造类：
                      <el-checkbox label="MES" value="MES"></el-checkbox>
                      <el-checkbox label="APS" value="APS"></el-checkbox>
                      <el-checkbox label="PLM" value="PLM"></el-checkbox>
                      <el-checkbox label="PMD" value="PMD"></el-checkbox>
                      <el-checkbox
                        label="其他生产制造软件"
                        value="其他生产制造软件"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.sczzType"
                        placeholder="请输入其他生产制造软件-具体描述"
                        v-if="this.demandForm.deployed.indexOf('其他生产制造软件') != -1"
                      ></el-input>
                    </div>
                    <div>
                      质量管理类：
                      <el-checkbox label="QMS" value="QMS"></el-checkbox>
                      <el-checkbox label="LIMS" value="LIMS"></el-checkbox>
                      <el-checkbox
                        label="其他质量管理软件"
                        value="其他质量管理软件"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.zlglType"
                        placeholder="请输入其他质量管理软件-具体描述"
                        v-if="this.demandForm.deployed.indexOf('其他质量管理软件') != -1"
                      ></el-input>
                    </div>
                    <div>
                      运营管理类：
                      <el-checkbox label="ERP" value="ERP"></el-checkbox>
                      <el-checkbox label="CRM" value="CRM"></el-checkbox>
                      <el-checkbox label="SRM" value="SRM"></el-checkbox>
                      <el-checkbox label="SCM" value="SCM"></el-checkbox>
                      <el-checkbox label="OA" value="OA"></el-checkbox>
                      <el-checkbox label="BI" value="BI"></el-checkbox>
                      <el-checkbox label="FMIS" value="FMIS"></el-checkbox>
                      <el-checkbox
                        label="其他运营管理软件"
                        value="其他运营管理软件"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.yyglType"
                        placeholder="请输入其他运营管理软件-具体描述"
                        v-if="this.demandForm.deployed.indexOf('其他运营管理软件') != -1"
                      ></el-input>
                    </div>
                    <div>
                      仓储物流类：
                      <el-checkbox label="BOM" value="BOM"></el-checkbox>
                      <el-checkbox label="WMS" value="WMS"></el-checkbox>
                      <el-checkbox
                        label="其他仓储物流软件"
                        value="其他仓储物流软件"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.ccwlType"
                        placeholder="请输入其他仓储物流软件-具体描述"
                        v-if="this.demandForm.deployed.indexOf('其他仓储物流软件') != -1"
                      ></el-input>
                    </div>
                    <div>
                      工业互联网平台：
                      <el-checkbox label="企业级" value="企业级"></el-checkbox>
                      <el-checkbox label="产业链级" value="产业链级"></el-checkbox>
                      <el-checkbox label="特定环节" value="特定环节"></el-checkbox>
                      <el-checkbox label="共享制造" value="共享制造"></el-checkbox>
                      <el-checkbox
                        label="电子商务平台"
                        value="电子商务平台"
                      ></el-checkbox>
                      <el-checkbox
                        label="厂区（园区）平台"
                        value="厂区（园区）平台"
                      ></el-checkbox>
                      <el-checkbox
                        label="其他工业互联网平台"
                        value="其他工业互联网平台"
                      ></el-checkbox>
                      <el-input
                        v-model="demandForm.gyhlwType"
                        placeholder="请输入其他工业互联网平台-具体描述"
                        v-if="
                          this.demandForm.deployed.indexOf('其他工业互联网平台') != -1
                        "
                      ></el-input>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="企业上云情况：" prop="migration" label-width="300px">
                  <el-checkbox-group
                    v-model="demandForm.migration"
                    @change="migrationChange"
                  >
                    <el-checkbox label="无" value="无"></el-checkbox>
                    <el-checkbox label="公有云" value="公有云"></el-checkbox>
                    <el-checkbox label="私有云" value="私有云"></el-checkbox>
                    <el-checkbox label="混合云" value="混合云"></el-checkbox>
                    <el-input
                      v-model="demandForm.describe"
                      placeholder="上云应用描述"
                      v-if="
                        this.demandForm.migration.indexOf('公有云') != -1 ||
                        this.demandForm.migration.indexOf('私有云') != -1 ||
                        this.demandForm.migration.indexOf('混合云') != -1
                      "
                    ></el-input>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="需要数字化转型的场景："
                  prop="scene"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="demandForm.scene"
                    style="font-size: 14px; color: #606266"
                  >
                    <div>
                      <el-checkbox label="*产品设计" value="产品设计"></el-checkbox>
                      <el-checkbox label="工艺设计" value="工艺设计"></el-checkbox>
                      <el-checkbox label="*营销管理" value="营销管理"></el-checkbox>
                      <el-checkbox label="售后服务" value="售后服务"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="计划排程" value="计划排程"></el-checkbox>
                      <el-checkbox label="*生产管控" value="生产管控"></el-checkbox>
                      <el-checkbox label="*质量管理" value="质量管理"></el-checkbox>
                      <el-checkbox label="*设备管理" value="设备管理"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="*安全生产" value="安全生产"></el-checkbox>
                      <el-checkbox label="*能耗管理" value="能耗管理"></el-checkbox>
                      <el-checkbox label="*采购管理" value="采购管理"></el-checkbox>
                      <el-checkbox label="*仓储管理" value="仓储管理"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="*财务管理" value="财务管理"></el-checkbox>
                      <el-checkbox label="人力资源" value="人力资源"></el-checkbox>
                      <el-checkbox label="协调办公" value="协调办公"></el-checkbox>
                      <el-checkbox label="决策支持" value="决策支持"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="其他" value="其他"></el-checkbox>
                      <el-input
                        v-model="demandForm.otherScene"
                        placeholder="其他-具体描述"
                        v-if="this.demandForm.scene.indexOf('其他') != -1"
                      ></el-input>
                    </div>
                    <div style="margin-top: 10px">
                      带“*”为约束性场景（共计10项），是引导企业深度改造的重点场景；剩余为指导性场景（共计6项）。
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 5px">
                      详情见：数字化经营应用场景等级判定表（可在“服务与支持”处下载）
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="上一年度数字化转型投入情况："
                  prop="oldMoney"
                  label-width="300px"
                >
                  <el-checkbox-group
                    v-model="demandForm.oldMoney"
                    @change="oldMoneyChange"
                  >
                    <el-checkbox
                      label="无相关实际投入"
                      value="无相关实际投入"
                    ></el-checkbox>
                    <el-checkbox label="50万元以内" value="50万元以内"></el-checkbox>
                    <el-checkbox label="50万-100万" value="50万-100万"></el-checkbox>
                    <el-checkbox label="100万-200万" value="100万-200万"></el-checkbox>
                    <el-checkbox label="200万以上" value="200万以上"></el-checkbox>
                    <el-input
                      v-model="demandForm.oldDescribe"
                      placeholder="需要填写服务商名称"
                      v-if="
                        this.demandForm.oldMoney.indexOf('50万元以内') != -1 ||
                        this.demandForm.oldMoney.indexOf('50万-100万') != -1 ||
                        this.demandForm.oldMoney.indexOf('100万-200万') != -1 ||
                        this.demandForm.oldMoney.indexOf('200万以上') != -1
                      "
                    ></el-input>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="数字化转型投入预算（年度预算）："
                  prop="budget"
                  label-width="300px"
                >
                  <el-checkbox-group v-model="demandForm.budget" @change="budgetChange">
                    <el-checkbox label="15万以内" value="15万以内"></el-checkbox>
                    <el-checkbox label="15万-30万" value="15万-30万"></el-checkbox>
                    <el-checkbox label="30万-50万" value="30万-50万"></el-checkbox>
                    <el-checkbox label="50万-100万" value="50万-100万"></el-checkbox>
                    <el-checkbox label="100万以上" value="100万以上"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="declareBtn">
            <el-button
              type="primary"
              plain
              @click="submitDigitize('basisForm', 'demandForm')"
              style="width: 50%; height: 60%; font-size: 24px; font-weight: 600"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import axios from "axios";

export default {
  data() {
    return {
      clickDig: 1,
      model: "scgl",
      isModelDetail: false,
      modelDetailKey: false,
      usVisible: false,
      isKK: true,
      rules: {
        contact: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
        email: [{ type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入咨询内容", trigger: "blur" }],
      },
      modelDetail: {
        titel: "",
        data: [],
      },
      messageFrom: {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      },
      basisForm: {
        name: "",
        site: "",
        uscc: "",
        industry: "",
        lr: "",
        phone: "",
        industryDetail: [],
        siteDetail: "",
        nature: [],
        scale: [],
        situation: [],
        money: "",
        profit: "",
        num: "",
        contactsName: "",
        contactsPhone: "",
        contactsPosition: "",
        contactsEmail: "",
        startTime: "",
        basic: "",
      },
      basisRules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        site: [{ required: true, message: "请选择所属县（区）", trigger: "change" }],
        uscc: [{ required: true, message: "请输入统一社会信用代码", trigger: "blur" }],
        industry: [{ required: true, message: "请输入行业代码", trigger: "blur" }],
        lr: [{ required: true, message: "请输入法人代表", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
        industryDetail: [
          {
            type: "array",
            required: true,
            message: "请选择一个细分行业",
            trigger: "change",
          },
        ],
        siteDetail: [{ required: true, message: "请输入注册地址", trigger: "blur" }],
        nature: [
          {
            type: "array",
            required: true,
            message: "请选择一个企业性质",
            trigger: "change",
          },
        ],
        scale: [
          {
            type: "array",
            required: true,
            message: "请选择一个企业规模",
            trigger: "change",
          },
        ],
        situation: [
          {
            type: "array",
            required: true,
            message: "请选择一个优质中小企业情况",
            trigger: "change",
          },
        ],
        money: [
          { required: true, message: "请输入2024年营业收入", trigger: "blur" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "blur" },
        ],
        profit: [
          { required: true, message: "请输入2024年净利润", trigger: "blur" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "blur" },
        ],
        num: [
          // { required: true, message: "请输入2024年员工数量", trigger: "blur" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "blur" },
        ],
        contactsName: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
        contactsPhone: [{ required: true, message: "请输入联系人电话", trigger: "blur" }],
        contactsPosition: [
          { required: true, message: "请输入联系人职务", trigger: "blur" },
        ],
        contactsEmail: [{ required: true, message: "请输入联系人邮箱", trigger: "blur" }],
        startTime: [
          {
            required: true,
            message: "请选择企业数字化转型预计启动时间",
            trigger: "change",
          },
        ],
        basic: [{ required: true, message: "请输入企业基本情况", trigger: "blur" }],
      },
      demandForm: {
        nowGrade: [],
        futureGrade: [],
        deployed: [],
        yfsjType: "",
        sczzType: "",
        zlglType: "",
        yyglType: "",
        ccwlType: "",
        gyhlwType: "",
        migration: [],
        describe: "",
        scene: [],
        otherScene: "",
        oldMoney: [],
        oldDescribe: "",
        budget: [],
      },
      demandRules: {
        nowGrade: [
          { required: true, message: "请选择现数字化水平等级", trigger: "change" },
        ],
        futureGrade: [
          {
            required: true,
            message: "请选择预计改造后数字化水平等级",
            trigger: "change",
          },
        ],
        deployed: [{ required: true, message: "请选择已部署软件", trigger: "change" }],
        migration: [{ required: true, message: "请选择企业上云情况", trigger: "change" }],
        scene: [
          { required: true, message: "请选择需要数字化转型的场景", trigger: "change" },
        ],
        oldMoney: [
          {
            required: true,
            message: "请选择上一年度数字化转型投入情况",
            trigger: "change",
          },
        ],
        budget: [
          {
            required: true,
            message: "请选择数字化转型投入预算（年度预算）",
            trigger: "change",
          },
        ],
      },
      district: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          this.queryCust(node).then((res) => {
            resolve(res);
          });
        },
      },
    };
  },
  mounted() {
    this.isModelDetail =
      this.model == "jhpc" ||
      this.model == "scgl" ||
      this.model == "ccgl" ||
      this.model == "zlgl" ||
      this.model == "yxgl" ||
      this.model == "cggl" ||
      this.model == "sbgl" ||
      this.model == "jczc";
    this.modelDetail.titel =
      "生产管理是企业运营管理的核心部分，其目的是确保产品能够按照质量、成本和交期的要求顺利生产。";
    this.modelDetail.data = [
      {
        id: 1,
        titel: "计划排程",
        function: "合理安排生产任务和资源配置。",
        content: ["生产计划管理；", "物料需求与供应管理；", "工艺路线与作业指导；"],
        target: "提高生产效率，以实现高效、有序的生产。",
        img: require("../assets/scgl (7).png"),
      },
      {
        id: 2,
        titel: "生产任务下达与执行",
        function: "将计划转化为具体生产任务并执行。",
        content: [
          "生产工单（任务编号、产品、数量、交期）；",
          "生产排程（工序安排、设备分配、人员安排）；",
          "实际开工与完工时间记录；",
          "工序流转卡与作业进度反馈；",
        ],
        target: "实现任务可追踪，进度可控制。",
        img: require("../assets/scgl (2).png"),
      },
      {
        id: 3,
        titel: "生产进度监控",
        function: "实时掌握生产进度，及时发现异常。",
        content: [
          "实际进度与计划对比；",
          "工序完成率、生产节拍；",
          "延误原因分析（设备故障、物料短缺等）；",
          "异常预警与处理记录；",
        ],
        target: "提高生产透明度，保障按时交付。",
        img: require("../assets/scgl (3).png"),
      },
      {
        id: 4,
        titel: "人员与班组管理",
        function: "对生产人员的工作安排与绩效进行管理。",
        content: [
          "人员基本信息（技能、岗位）；",
          "班组配置与班次安排；",
          "工时记录与绩效考核；",
        ],
        target: "优化人力资源配置，提升操作效率。",
        img: require("../assets/scgl (1).png"),
      },
      {
        id: 5,
        titel: "生产数据采集与分析",
        function: "收集生产过程中各项数据并进行分析。",
        content: [
          "产量、工时、效率等关键指标；",
          "质量合格率、设备故障率；",
          "成本与资源消耗分析；",
          "数据可视化与报表输出；",
        ],
        target: "支持生产决策，推动持续改进。",
        img: require("../assets/scgl (6).png"),
      },
      {
        id: 6,
        titel: "产品质量管理与控制",
        function: "对生产过程中的质量进行监控与控制。",
        content: [
          "质量检验标准（原材料、半成品、成品）；",
          "检验记录与不合格品处理；",
          "质量问题分析与改进措施；",
          "质量追溯；",
        ],
        target: "确保产品质量稳定，减少不良品。",
        img: require("../assets/scgl (5).png"),
      },
    ];
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
  },
  methods: {
    change(item) {
      this.clickDig = item;
    },
    replace(item) {
      this.model = item;
      this.isModelDetail = true;
      this.modelDetailKey = !this.modelDetailKey;
      if (item == "jhpc") {
        this.modelDetail.titel =
          "计划排程是企业生产管理过程中的重要环节，其目的是合理安排生产任务和资源配置，提高生产效率，以实现高效、有序的生产。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "生产订单管理",
            function: "接收和管理客户订单，作为排产的原始输入。",
            content: [
              "客户名称、订单编号；",
              "产品型号、数量、规格；",
              "交货日期、优先级；",
              "订单状态（已确认、待审核、已排产）；",
            ],
            target: "实现设备全生命周期的信息化管理。",
            img: require("../assets/jhpc (1).png"),
          },
          {
            id: 2,
            titel: "工艺路线管理",
            function: "定义产品加工的工序流程和操作规范。",
            content: [
              "工序编号、名称、顺序；",
              "每道工序的工时定额；",
              "所需设备、工具、人员技能要求；",
              "工序之间的逻辑关系（串行/并行）；",
            ],
            target: "为排程提供准确的工序逻辑和资源需求。",
            img: require("../assets/jhpc (3).png"),
          },
          {
            id: 3,
            titel: "物料需求计划（MRP）",
            function: "根据生产计划计算所需物料种类和数量。",
            content: [
              "BOM（物料清单）；",
              "库存数据（现有库存、在途库存）；",
              "采购计划、自制件计划；",
            ],
            target: "确保物料按时到位，支撑生产计划执行。",
            img: require("../assets/jhpc (5).png"),
          },
          {
            id: 4,
            titel: "主生产计划（MPS）",
            function: "制定最终产品的生产计划，协调销售与生产的平衡。",
            content: [
              "产品名称、计划数量；",
              "计划开始与完成时间；",
              "资源需求（设备、人力、原材料）；",
              "与销售预测的对比分析；",
            ],
            target: "形成可执行的中短期生产计划。",
            img: require("../assets/jhpc (7).png"),
          },
          {
            id: 5,
            titel: "生产排程与调度模块",
            function: "将生产任务分配到具体时间、设备和人员。",
            content: [
              "工单编号、产品名称、数量；",
              "排程时间表（开始时间、结束时间）；",
              "工序分配、设备分配、班组安排；",
              "排程调整记录；",
            ],
            target: "实现生产任务的时间与资源精确匹配。",
            img: require("../assets/jhpc (4).png"),
          },
        ];
      } else if (item == "scgl") {
        this.modelDetail.titel =
          "生产管理是企业运营管理的核心部分，其目的是确保产品能够按照质量、成本和交期的要求顺利生产。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "计划排程",
            function: "合理安排生产任务和资源配置。",
            content: ["生产计划管理；", "物料需求与供应管理；", "工艺路线与作业指导；"],
            target: "提高生产效率，以实现高效、有序的生产。",
            img: require("../assets/scgl (7).png"),
          },
          {
            id: 2,
            titel: "生产任务下达与执行",
            function: "将计划转化为具体生产任务并执行。",
            content: [
              "生产工单（任务编号、产品、数量、交期）；",
              "生产排程（工序安排、设备分配、人员安排）；",
              "实际开工与完工时间记录；",
              "工序流转卡与作业进度反馈；",
            ],
            target: "实现任务可追踪，进度可控制。",
            img: require("../assets/scgl (2).png"),
          },
          {
            id: 3,
            titel: "生产进度监控",
            function: "实时掌握生产进度，及时发现异常。",
            content: [
              "实际进度与计划对比；",
              "工序完成率、生产节拍；",
              "延误原因分析（设备故障、物料短缺等）；",
              "异常预警与处理记录；",
            ],
            target: "提高生产透明度，保障按时交付。",
            img: require("../assets/scgl (3).png"),
          },
          {
            id: 4,
            titel: "人员与班组管理",
            function: "对生产人员的工作安排与绩效进行管理。",
            content: [
              "人员基本信息（技能、岗位）；",
              "班组配置与班次安排；",
              "工时记录与绩效考核；",
            ],
            target: "优化人力资源配置，提升操作效率。",
            img: require("../assets/scgl (1).png"),
          },
          {
            id: 5,
            titel: "生产数据采集与分析",
            function: "收集生产过程中各项数据并进行分析。",
            content: [
              "产量、工时、效率等关键指标；",
              "质量合格率、设备故障率；",
              "成本与资源消耗分析；",
              "数据可视化与报表输出；",
            ],
            target: "支持生产决策，推动持续改进。",
            img: require("../assets/scgl (6).png"),
          },
          {
            id: 6,
            titel: "产品质量管理与控制",
            function: "对生产过程中的质量进行监控与控制。",
            content: [
              "质量检验标准（原材料、半成品、成品）；",
              "检验记录与不合格品处理；",
              "质量问题分析与改进措施；",
              "质量追溯；",
            ],
            target: "确保产品质量稳定，减少不良品。",
            img: require("../assets/scgl (5).png"),
          },
        ];
      } else if (item == "zlgl") {
        this.modelDetail.titel =
          "质量管理是企业在产品或服务的整个经营过程中的核心环节，主要用于确保产品或服务质量满足客户要求和相关标准。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "来料检验（IQC）",
            function: "对供应商提供的原材料进行质量检验。",
            content: [
              "来料批次、供应商信息；",
              "检验标准、抽样方案；",
              "检验记录与结果（合格/不合格）；",
              "不合格品处理流程（退货、让步接收等）；",
            ],
            target: "防止不合格原材料流入生产流程。",
            img: require("../assets/zlgl (1).png"),
          },
          {
            id: 2,
            titel: "过程质量控制（IPQC）",
            function: "对生产过程中的各工序进行质量监控。",
            content: [
              "工序控制点（关键质量特性）；",
              "首件检验、巡检记录；",
              "人员、设备、工艺参数监控；",
              "异常报告与纠正措施（如8D、5WHY）；",
            ],
            target: "确保生产过程稳定，预防质量缺陷。",
            img: require("../assets/zlgl (4).png"),
          },
          {
            id: 3,
            titel: "最终检验（FQC）与出货检验（OQC）",
            function: "对成品进行最终质量检验和出货前检查。",
            content: [
              "成品批次、订单号；",
              "检验项目与标准；",
              "包装、标签、标识检查；",
              "出货检验报告与放行记录；",
            ],
            target: "确保交付产品符合客户要求与标准。",
            img: require("../assets/zlgl (1).png"),
          },
          {
            id: 4,
            titel: "质量数据分析与统计模块",
            function: "对质量数据进行汇总、分析与反馈。",
            content: [
              "各类质量报表（合格率、缺陷率）；",
              "质量趋势图；",
              "不合格原因分类；",
              "质量成本分析；",
            ],
            target: "发现问题根源，支持持续改进。",
            img: require("../assets/zlgl (3).png"),
          },
          {
            id: 5,
            titel: "不合格品处理与追溯模块",
            function: "对不合格品进行分类、处理与追踪。",
            content: [
              "不合格品标识、隔离记录；",
              "处理方式（返工、报废、挑选）；",
              "不合格品流向追溯（从原材料到成品）；",
              "客户退货与投诉处理记录；",
            ],
            target: "防止不合格品误用，实现质量可追溯。",
            img: require("../assets/zlgl (2).png"),
          },
          {
            id: 6,
            titel: "质量改进与问题解决模块",
            function: "推动质量问题的根本原因分析与改进。",
            content: [
              "质量问题记录与分类；",
              "根本原因分析；",
              "纠正与预防措施；",
              "改进效果跟踪与验证；",
            ],
            target: "实现质量问题闭环管理。",
            img: require("../assets/zlgl (3).png"),
          },
        ];
      } else if (item == "sbgl") {
        this.modelDetail.titel =
          "设备管理是企业保障生产顺利进行的重要环节，其核心目标是提高设备利用率、降低故障率、延长设备寿命、保障生产连续性。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "设备档案管理",
            function: "建立和维护设备的基本信息档案。",
            content: [
              "设备编号、名称、型号、规格；",
              "制造商、购置日期、投入使用日期；",
              "安装位置、使用部门；",
              "设备状态（运行、停用、维修、报废）；",
              "设备图纸、技术资料、操作手册；",
            ],
            target: "实现设备全生命周期的信息化管理。",
            img: require("../assets/sbgl (1).png"),
          },
          {
            id: 2,
            titel: "设备采购与验收",
            function: "管理设备的采购申请、采购过程及到货验收。",
            content: [
              "采购申请（设备名称、数量、用途）；",
              "采购合同（供应商、价格、交货期）；",
              "到货验收记录（验收人、验收时间、验收结果）；",
              "设备安装调试记录；",
            ],
            target: "确保设备符合技术要求，及时投入使用。",
            img: require("../assets/sbgl (2).png"),
          },
          {
            id: 3,
            titel: "设备维护保养",
            function: "对设备进行预防性和纠正性维护。",
            content: [
              "保养计划（保养周期、保养内容）；",
              "保养记录（执行时间、执行人、保养结果）；",
              "维修申请与维修记录（故障描述、维修措施、维修时间）；",
              "备品备件更换记录；",
            ],
            target: "延长设备寿命，降低故障率。",
            img: require("../assets/sbgl (3).png"),
          },
          {
            id: 4,
            titel: "设备故障管理",
            function: "记录和分析设备故障，优化维护策略。",
            content: [
              "故障发生时间、设备编号、故障现象；",
              "故障原因分析（人为、机械、电气等）；",
              "故障处理过程与结果；",
              "故障趋势分析；",
            ],
            target: "预防重复性故障，提升设备稳定性。",
            img: require("../assets/sbgl (5).png"),
          },
          {
            id: 5,
            titel: "设备点检管理",
            function: "通过定期点检发现设备潜在问题。",
            content: [
              "点检计划（点检周期、点检项目）；",
              "点检标准（判断是否正常的依据）；",
              "点检记录（执行人、点检结果）；",
              "异常处理记录；",
            ],
            target: "实现设备状态的早期预警。",
            img: require("../assets/sbgl (4).png"),
          },
        ];
      } else if (item == "yxgl") {
        this.modelDetail.titel =
          "营销管理是企业经营过程中的核心职能之一，主要负责连接市场需求与生产活动，确保产品能够满足客户需求并顺利销售。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "客户关系管理（CRM）",
            function: "管理客户信息与互动，提升客户满意度。",
            content: [
              "客户基本信息（名称、地址、联系人）；",
              "客户订单历史与交易记录；",
              "客户沟通记录、投诉与服务反馈；",
              "客户等级与信用评估；",
            ],
            target: "建立长期客户关系，提高复购率。",
            img: require("../assets/yxgl (1).png"),
          },
          {
            id: 2,
            titel: "订单管理模块",
            function: "管理客户订单。",
            content: [
              "客户订单（产品、数量、交期、价格）；",
              "订单状态（待确认、已排产、已发货、已完成）；",
              "订单变更与取消记录；",
            ],
            target: "将市场需求转化为可执行的生产订单。",
            img: require("../assets/yxgl (2).png"),
          },
          {
            id: 3,
            titel: "合同管理模块",
            function: "管理销售合同。",
            content: [
              "合同模板、合同条款；",
              "合同审批流程、执行状态；",
              "合同回款计划变动与回款记录；",
            ],
            target: "规范销售行为，控制风险。",
            img: require("../assets/yxgl (3).png"),
          },
        ];
      } else if (item == "cggl") {
        this.modelDetail.titel =
          "采购管理是企业经营过程中的关键支持职能，主要负责获取企业所需物资、服务或外包资源，以确保生产顺利进行和成本控制。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "采购需求计划模块",
            function: "根据生产计划、库存状况生成采购需求。",
            content: [
              "生产计划（MPS）；",
              "物料需求计划（MRP）数据；",
              "安全库存、最低库存设定；",
              "采购申请单（物料名称、规格、数量）；",
            ],
            target: "确保物料按时到位，支撑生产计划执行。",
            img: require("../assets/cggl (1).png"),
          },
          {
            id: 2,
            titel: "到货与验收管理模块",
            function: "对采购物料进行到货登记与质量检验。",
            content: [
              "到货通知单、送货单；",
              "实际到货数量、包装状态；",
              "来料检验结果（合格/不合格）；",
              "不合格品处理流程（退货、换货、让步接收）；",
            ],
            target: "确保物料质量与数量符合要求。",
            img: require("../assets/cggl (2).png"),
          },
          {
            id: 3,
            titel: "采购入库与库存对接模块",
            function: "将合格物料办理入库并更新库存信息。",
            content: [
              "入库单编号、物料编码、数量；",
              "入库时间、库位信息；",
              "库存状态（可用库存、冻结库存、在途库存）；",
              "与ERP系统库存数据同步；",
            ],
            target: "确保物料及时可用，支持生产计划执行。",
            img: require("../assets/cggl (3).png"),
          },
          {
            id: 4,
            titel: "采购订单管理模块",
            function: "生成和管理采购订单，跟踪执行情况。",
            content: [
              "采购订单编号、物料明细；",
              "订单数量、单价、总价；",
              "订单日期、交货日期、付款方式；",
              "订单状态（已下单、已发货、部分到货、已完成）；",
            ],
            target: "确保物料按时、按质、按量交付。",
            img: require("../assets/cggl (4).png"),
          },
          {
            id: 5,
            titel: "采购合同管理模块",
            function: "管理采购合同的签订与执行。",
            content: [
              "合同编号、合同金额、签订日期；",
              "合同条款（付款方式、违约责任、质量标准）；",
              "合同履行状态（执行中、已完成、已终止）；",
              "合同变更与补充协议记录；",
            ],
            target: "规范采购行为，防范法律风险。",
            img: require("../assets/cggl (5).png"),
          },
          {
            id: 6,
            titel: "付款与应付账款管理模块",
            function: "处理采购付款流程与应付账款。",
            content: [
              "采购发票；",
              "付款申请；",
              "付款计划、实际付款记录；",
              "应付账款台账；",
            ],
            target: "规范资金支付流程，控制财务风险。",
            img: require("../assets/cggl (6).png"),
          },
          {
            id: 7,
            titel: "供应商管理模块",
            function: "对供应商进行评估、分类与动态管理。",
            content: [
              "供应商基本信息（名称、地址、联系方式）；",
              "供应商资质、认证情况（如ISO、行业认证）；",
              "供应商评估指标（交货准时率、质量合格率、服务响应）；",
            ],
            target: "建立稳定、可靠的供应商资源库。",
            img: require("../assets/cggl (7).png"),
          },
        ];
      } else if (item == "ccgl") {
        this.modelDetail.titel =
          "仓储管理是物流管理中的核心环节，通常包括以下几个主要模块，每个模块在仓储流程中承担不同的功能。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "入库管理",
            function: "负责货物进入仓库的全过程管理。",
            content: [
              "供应商信息（名称、联系方式等）；",
              "入库单信息（单号、日期、货品明细）；",
              "货物检验（数量、质量、包装检查）；",
              "上架策略（根据货品类别、存储条件分配货位）；",
            ],
            target: "确保货物准确、安全、高效地进入仓库。",
            process: "pc端创建入库单→手机端点击入库→找对应入库单扫码入库",
            img: require("../assets/ccgl (1).png"),
          },
          {
            id: 2,
            titel: "出库管理",
            function: "处理客户或内部需求的货物出库流程。",
            content: [
              "出库单信息（客户、时间、货品明细）；",
              "拣货路径（根据货位优化拣货顺序）；",
              "包装信息（出库货物的包装方式）；",
              "出库校验（核对出库货物与订单是否一致）；",
            ],
            target: "确保货物按时、准确地发出。",
            process: "pc端创建出库单→手机端点击出库→找到对应出库单扫码出库",
            img: require("../assets/ccgl (2).png"),
          },
          {
            id: 3,
            titel: "库存管理",
            function: "对仓库内所有货物的数量、状态和位置进行动态管理。",
            content: [
              "库存数量、批次、有效期货位信息（货物存放位置）；",
              "库存预警（库存上下限提醒）；",
              "库存盘点（定期或循环盘点数据）；",
            ],
            target: "确保库存数据准确，防止积压或缺货。",
            img: require("../assets/ccgl (3).png"),
          },
          {
            id: 4,
            titel: "报表与分析",
            function: "提供仓储运营数据的统计与分析。",
            content: [
              "入库、出库、库存统计报表；",
              "操作效率分析（如拣货效率、出入库速度）；",
              "成本分析（仓储成本、人工成本等）；",
            ],
            target: "支持管理决策，提升仓储运营效率。",
            img: require("../assets/ccgl (4).png"),
          },
          {
            id: 5,
            titel: "调拨管理",
            function: "处理不同仓库或货位之间的货物调拨。",
            content: [
              "调拨申请（调出仓库、调入仓库、货物信息）；",
              "调拨单据（调拨时间、责任人）；",
              "调拨状态（运输中、已确认、关结）；",
            ],
            target: "优化库存分布，提高资源利用率。",
            img: require("../assets/ccgl (5).png"),
          },
          {
            id: 6,
            titel: "盘点管理",
            function: "定期或不定期对库存货物进行清点核对。",
            content: [
              "盘点计划（时间、范围、人员）；",
              "盘点结果（实际数量与系统数量对比）；",
              "差异处理（差异原因分析与调整记录）；",
            ],
            target: "确保库存账实相符，提高库存准确性。",
            img: require("../assets/ccgl (6).png"),
          },
          {
            id: 7,
            titel: "退货管理",
            function: "处理客户退回或供应商退货的流程。",
            content: [
              "退货原因（质量问题、错发等）；",
              "退货检验（是否可重新入库或需维修/报废）；",
              "退货处理（重新上架、返修、退货给供应商）；",
            ],
            target: "规范退货流程，减少损失，提升客户满意度。",
            img: require("../assets/ccgl (7).png"),
          },
        ];
      } else if (item == "jczc") {
        this.modelDetail.titel =
          "决策支持是企业经营过程中的智能分析中枢，负责收集、分析和展示企业运营数据，提供可视化数据,为企业提供科学的决策依据。";
        this.modelDetail.data = [
          {
            id: 1,
            titel: "数据采集与整合模块",
            function: "从各业务系统（ERP、MES、SCM等）中提取并整合数据。",
            content: [
              "生产、采购、库存、销售、财务等业务数据；",
              "实时与历史数据采集；",
              "数据清洗、标准化与整合；",
              "数据仓库（DW）与数据湖建设；",
            ],
            target: "为决策提供全面、准确、一致的数据基础。",
            img: require("../assets/jczc (1).png"),
          },
          {
            id: 2,
            titel: "多维度可视化与报表分析模块",
            function: "将数据分析结果以图表方式呈现。",
            content: [
              "仪表盘（Dashboard）、趋势图、热力图；",
              "按产品、区域、客户、时间等维度分析；",
              "自定义报表模板与导出功能；",
              "数据钻取、联动与实时更新；",
            ],
            target: "提升信息可视化水平，支持快速决策。",
            img: require("../assets/jczc (2).png"),
          },
        ];
      }
    },
    openUs(item) {
      this.messageChange();
      this.messageFrom.content = item;
      this.usVisible = true;
    },
    submitMessage(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const messageDto = {
            type: 0,
            name: this.messageFrom.name,
            contact: this.messageFrom.contact,
            email: this.messageFrom.email,
            company: this.messageFrom.company,
            site: this.messageFrom.site,
            content: this.messageFrom.content,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/add", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("留言成功");
                this.messageChange();
                this.usVisible = false;
              } else {
                ElMessage.error("留言失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("留言失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    messageChange() {
      this.messageFrom = {
        name: "",
        contact: "",
        email: "",
        company: "",
        content: "",
        site: "",
      };
    },
    handleSelectCus(value) {
      console.log("------", value);
    },
    queryCust(node) {
      return new Promise((resolve) => {
        axios
          .get("/district/queryByPid", {
            params: { pid: node.value ? node.value : 1 },
          }) // 使用创建的api实例: api.post('/your-endpoint', payload)
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              let option = response.data.data.map((item) => {
                return {
                  label: item.district,
                  value: item.id,
                  leaf: item.level > 2,
                };
              });
              resolve(option);
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("地区获取失败，请检查网络或接口地址");
            console.error("地区获取失败", error);
            resolve([]);
          });
      });
    },
    industryDetailChange(value) {
      if (value.length > 1) {
        this.basisForm.industryDetail = [value[value.length - 1]];
      }
    },
    natureChange(value) {
      if (value.length > 1) {
        this.basisForm.nature = [value[value.length - 1]];
      }
    },
    scaleChange(value) {
      if (value.length > 1) {
        this.basisForm.scale = [value[value.length - 1]];
      }
    },
    situationChange(value) {
      if (value.length > 1) {
        this.basisForm.situation = [value[value.length - 1]];
      }
    },
    nowGradeChange(value) {
      if (value.length > 1) {
        this.demandForm.nowGrade = [value[value.length - 1]];
      }
    },
    futureGradeChange(value) {
      if (value.length > 1) {
        this.demandForm.futureGrade = [value[value.length - 1]];
      }
    },
    migrationChange(value) {
      if (value.length > 1) {
        this.demandForm.migration = [value[value.length - 1]];
      }
    },
    oldMoneyChange(value) {
      if (value.length > 1) {
        this.demandForm.oldMoney = [value[value.length - 1]];
      }
    },
    budgetChange(value) {
      if (value.length > 1) {
        this.demandForm.budget = [value[value.length - 1]];
      }
    },
    submitDigitize(Ref1, Ref2) {
      console.log("-----11111", this.basisForm);
      console.log("-----22222", this.demandForm);
      this.$refs[Ref1].validate((valid1) => {
        this.$refs[Ref2].validate((valid2) => {
          if (valid1 && valid2) {
            console.log("-----11111", this.basisForm);
            console.log("-----22222", this.demandForm);
          } else {
            ElMessage.error("请填写所有必填项");
          }
        });
      });
    },
  },
};
</script>
<style>
.digitize {
  padding-top: 20px;
}
.digitize_banner {
  width: 100%;
  display: flex;
  flex-direction: column; /* 使子元素垂直排列 */
  /* align-items: center; 水平居中 */
  justify-content: center; /* 垂直居中 */
  position: relative; /* 对于绝对定位的文本 */
  height: 470px;
}
.digitize_banner img {
  width: 100%; /* 或者你希望的宽度 */
  /* height: auto; 保持图片比例 */
  height: 460px;
}
.digitize_model {
  line-height: 30px;
  font-size: 16px;
  width: 100%;
  border-radius: 1.04vw;
  /* box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1); */
  margin-bottom: 30px;
}
.dig_item {
  width: 50%;
  text-align: center;
  justify-items: center;
}
.digitize_item {
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 5px;
  border-radius: 1.04vw;
  text-align: center;
  width: 30%;
}
.dig_item:hover .digitize_item {
  background: #317cdf;
  color: white;
  font-weight: 600;
}
.digitize_item_d {
  padding-top: 10px;
  padding-bottom: 10px;
  width: 30%;
  margin: 5px;
  text-align: center;
  border-radius: 1.04vw;
  background: #317cdf;
  color: white;
  font-weight: 600;
}
.digi_title {
  text-align: center;
  font-size: 38px;
  color: #1483ff;
  font-weight: 600;
  margin-bottom: 5px;
}
.digi_title_detail {
  font-size: 14px;
  color: #606266;
  text-align: center;
  /* margin-bottom: 20px; */
}
.title_img {
  width: 100px;
  padding-left: 80px;
}
@keyframes flyBottomIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes flyTopIn {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes flyRightIn {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes flyLeftIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.tit_img {
  width: 100%;
  border-radius: 1.04vw;
  border: 0.2px solid #efefef;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
}

.t_img {
  width: 80%;
  animation: flyBottomIn 1s ease-out forwards;
  cursor: pointer;
}
.t_img:hover {
  width: 100%;
  border-radius: 1.04vw;
  border: 0.2px solid #efefef;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
}
.t_img_wen {
  font-size: 15px;
  color: #1483ff;
  font-weight: 600;
  text-align: center;
}
.digi_detail_left {
  animation: flyLeftIn 1s ease-out forwards;
  display: flex;
  align-items: center;
  font-size: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
}
.digi_detail_right {
  animation: flyRightIn 1s ease-out forwards;
  display: flex;
  align-items: center;
  font-size: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
}
.digi_detail_tit {
  padding-top: 20px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #1483ff;
  margin-bottom: 10px;
  margin-top: 40px;
  animation: flyBottomIn 1s ease-out forwards;
}
.digi_detail_wen {
  /* width: 50%; */
  padding-left: 20%;
}
.digi_detail_img {
  width: 50%;
  text-align: center;
}
.digi_detail_img img {
  width: 500px;
}
.jiachu {
  font-size: 16px;
  font-weight: 600;
  height: 36px;
  line-height: 36px;
}
.basis {
  margin: 10px;
  border-radius: 1.04vw;
  border: 0.2px solid #efefef;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
}
.demand {
  margin: 10px;
  margin-top: 30px;
  border-radius: 1.04vw;
  border: 0.2px solid #efefef;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
}
.basis_title {
  text-align: center;
  font-size: 42px;
  color: #4da0fc;
  font-weight: 700;
  margin-bottom: 30px;
  margin-top: 20px;
}
.basis_content {
  width: 88%;
  padding-bottom: 20px;
}
.declareBtn {
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.fw_wen {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 200%;
  text-indent: 2em;
  width: 67%;
  padding-left: 1vw;
  color: rgba(0, 0, 0, 0.65);
}
</style>
